<div class="flex-start-center">
    <div (click)="openPinItem()">{{name}}</div>
    <button (click)="removePinItem()" mat-icon-button>
        <mat-icon>close</mat-icon>
    </button>
</div>
